import { render, staticRenderFns } from "./registro_edicion_formato.vue?vue&type=template&id=16bacb82&scoped=true"
import script from "./registro_edicion_formato.vue?vue&type=script&lang=js"
export * from "./registro_edicion_formato.vue?vue&type=script&lang=js"
import style0 from "./registro_edicion_formato.vue?vue&type=style&index=0&id=16bacb82&prod&scoped=true&lang=css"
import style1 from "./registro_edicion_formato.vue?vue&type=style&index=1&id=16bacb82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bacb82",
  null
  
)

export default component.exports